<template>
	<div class="exam" v-if="status !== null">
		<div class="title" v-if="paper">{{paper.title}}</div>
		
		<div class="score-card" style="width: 230px;" v-if="paper && 1 === status || 2 === status">
			<div class="item" style="flex-direction: column;align-items: center;">
				<span style="padding:0;flex-basis:0;flex-grow:0;flex-shrink:0;" v-if="1 === status">距离开始</span>
				<span style="padding:0;flex-basis:0;flex-grow:0;flex-shrink:0;"
					  v-if="2 === status">距离交卷</span>
				<span style="width: auto;text-align: center;padding: 0;flex-basis:0;flex-grow:0;flex-shrink:0;"
					  v-if="status === 1 || status === 2"
				>{{timeLeft}}</span>
			</div>
		</div>
		
		<div class="score-card" style="width: 170px;text-align: center;" v-if="paper && 3 === status">
			<span>考试结束</span>
		</div>
		
		<div class="score-card" v-if="paper">
			<div class="item"><span>试卷总分</span><span>{{totalScore}}</span></div>
			<div class="item" v-if="showScore"><span>得分</span><span>{{score}}</span></div>
			<div class="item" v-if="nickname"><span>姓名</span><span>{{nickname}}</span></div>
		</div>
		
		<div class="example-card" v-if="showAnswers || showErrors">
			<div v-if="showAnswers"><i class="example"></i> 正确答案</div>
			<div v-if="showSubmits"><i class="example green"></i> 回答正确</div>
			<div v-if="showErrors"><i class="example red"></i> 回答错误</div>
		</div>
		
		<div v-if="paper && paper['data'] && showPaper">
			<component
					v-for="(item,index) in paper['data']"
					:key="index"
					:is="`${item.type}-component`"
					:data="item"
			/>
		</div>
		
		<!--		<a class="post-button" v-if="!disabled && 2 === status" @click="postExam(true, true)"-->
		<!--		   style="margin-bottom: 1rem;">保存</a>-->
		<a class="post-button" v-if="!disabled && 2 === status" @click="postExam(false)">交卷</a>
		<a class="post-button" v-if="!disabled && !showScore && 0 === status" @click="mark">评分</a>
		<a class="flat-button" v-if="showScore && 0 === status" @click="reset">重置</a>
		<!--		<a class="post-button" @click="postExam(false)">交卷</a>-->
		<!--		<a class="post-button" @click="postExam(true)" style="margin-top: 12px;">自动提交</a>-->
	</div>
</template>

<script>
    import Vue from "vue"
    // 引入mixins
    import mixins_config from "@/mixins/config.js";
    // 引入组件
    import TitleComponent from "../components/TitleComponent";
    import TextComponent from "../components/TextComponent";
    import ChoiceComponent from "../components/ChoiceComponent.vue";
    import ClozeComponent from "../components/ClozeComponent.vue";
    import ReadingComponent from "../components/ReadingComponent";
    import BlankComponent from "../components/BlankComponent.vue";
    // 引入接口
    import {GET_EXAM, SUBMIT_EXAM, GET_TIME} from "../utils/dataProvider.js";
    import {
        countScore, generateScore,
        getQuestionAnswers,
        getQuestionKeyMap,
        getTimeDelt,
        mergeSubmit,
        parseTime
    } from "../utils/functions";
    import {GET_PREVIEW, GET_SUBMIT} from "../utils/dataProvider";
    import RichComponent from "../components/RichComponent";
    import {clearLocalStorage, getLocalStorage, getStorage, setLocalStorage} from "../utils/cookie";

    export default {
        name: "Exam",
        mixins: [mixins_config],
        components: {
            RichComponent,
            TitleComponent,
            TextComponent,
            ChoiceComponent,
            ClozeComponent,
            ReadingComponent,
            BlankComponent
        },
        props: {
            //
            /**
             * 状态
             * exam 面向学生的考试状态
             * alpha 面向老师的预览状态
             * submit 面向考试的考试记录查看状态
             */
            mode: {
                type: String,
                default: 'exam'
            }
        },
        data() {
            return {
                // 倒计时
                timeLeftTimer: null,
                timeLeft: '',

                // 自动提交 计时器
                autoTimer: null,
				
				// 允许自动提交
				allowAuto: false,

                score: 0,
                nickname: null,

                // 正确答案集合
                answers: null,
            };
        },
        mounted() {
            // console.log('Exam mounted');
            let that = this;
            if (this.isLogin) {
                // TODO:以服务器时间为准
                // this.getTime();
                switch (that.mode) {
                    case 'preview':
                        // 预览模式
                        // 试题可答，不可提交，可以评分、重置
                        //console.log('预览模式');
                        this.getPreview(this.$route.params.id);
                        break;
                    case 'submit':
                        // 记录查看模式
                        // 与考试模式中考试结束后的类似
                        // 学生考试结束后，直接显示错题、答案
                        //console.log('记录查看模式');
                        this.getSubmit(this.$route.params.id);
                        break;
                    case 'exam':
                    default:
                        // 考试模式
                        this.getPaper(this.$route.params.id);
                        setLocalStorage('exam', this.$route.params.id)
                }
            }
        },
        destroyed() {
            this.clearTimer();
        },
        watch: {
            submits: {
                handler(n, o) {
                    if (this.answers && this.submits) {
                        this.score = generateScore(this.answers, this.submits);
                    }
                },
                deep: true
            }
        },
        methods: {
            getSubmit(id) {
                let that = this;
                return GET_SUBMIT(id, function (res) {
                    if (!res || !res.data || !res.data.paper) {
                        that.$message.error('获取记录失败');
                        return
                    }
                    //console.log(res.data);

                    // 初始化数据
                    that.app.submit = res.data;
                    that.app.paper = res.data.paper;

                    // 不可编辑
                    that.app.disabled = true;

                    // 当前的显示状态
                    that.app.status = 4;
                    that.app.showScore = true;
                    that.app.showSubmits = true;
                    that.app.showErrors = that.paper.show_errors;
                    that.app.showAnswers = that.paper.show_answers;


                    // 获取正确答案集合
                    that.answers = getQuestionAnswers(that.paper.data);

                    // 生成答案集合
                    that.app.submits = getQuestionKeyMap(that.paper.data);
                    if (that.submit && that.submit.data) {
                        mergeSubmit(that.submits, that.submit.data)
                    }

                    // 计算实时成绩
                    that.score = generateScore(that.submits);

                    // 其他数据
                    that.nickname = that.submit.nickname;

                    //console.log('答案集合', that.submits);
                }).catch(err => {
                    that.$message.error(err.response.data);
                });
            },
            clearTimer() {
                let that = this;
                if (that.timeLeftTimer) {
                    window.clearInterval(that.timeLeftTimer);
                    that.timeLeftTimer = null;
                }
                if (that.autoTimer) {
                    window.clearInterval(that.autoTimer);
                    that.autoTimer = null;
                }
            },

            /**
             * exam模式
             * 检查试卷状态
             */
            checkStatus() {
                let that = this;
                let now = (new Date()).getTime();
                let startsAt = parseTime(that.paper.starts_at).getTime();
                let endsAt = parseTime(that.paper.ends_at).getTime();

                if (!that.paper) {
                    that.$message.error('无试卷数据');
                    return;
                }
                if (!that.paper.starts_at || !that.paper.ends_at) {
                    // 考试时间异常
                    that.$message.error('考试时间异常');
                    return;
                }

                // 起止时间异常
                if (startsAt >= endsAt) {
                    that.$message.error('考试时间异常');
                    return;
                }

                // 清理定时器
                that.clearTimer();

                // 关闭自动提交
                that.allowAuto = false;

                // 初始状态判断
                if (3 === that.paper.status) {
                    // 试卷为公开查阅状态
                    // console.log('试卷为公开查阅状态');
                    that.app.status = 3;

                    // 基本状态
                    that.app.disabled = true;
                    that.app.showAnswers = true;
                    if (that.submit) {
                        that.app.showScore = true;
                        that.app.showSubmits = true;
                        that.app.showErrors = true;
                        that.score = that.submit.score;
                    } else {
                        that.app.showSubmits = false;
                        that.app.showErrors = false;
                    }

                    return;
                } else

                // 试卷为考试状态，考前、考中、考后都有可能，状态由以下条件判断
                //console.log('试卷为考试状态')

                // 考试时间检查
                if (now < startsAt) {
                    // 考试 还未开始
                    //console.log('考试 还未开始');

                    // 基本状态
                    that.app.status = 1;
                    that.app.disabled = true;
                    that.app.showErrors = false;
                    that.app.showAnswers = false;

                    // 考试前 定时器 step=1秒
                    that.timeLeft = getTimeDelt(now, startsAt);
                    that.timeLeftTimer = window.setInterval(function () {
                        let now = (new Date()).getTime();
                        that.timeLeft = getTimeDelt(now, startsAt);

                        if (startsAt <= now) {
                            // 考试开始，重新获取试卷数据
                            //console.log('考试开始，重新检查状态')

                            that.clearTimer();
                            that.getPaper(that.$route.params.id);
                        }
                    }, 1000);
                    return;
                } else if (startsAt < now && now < endsAt) {
                    // 考试 进行中
                    //console.log('考试 进行中');

                    // 判断是否有提交
                    if (that.submit) {
                        // 有提交

                        // 判断是否是最终提交
                        if (1 === that.submit.status) {
                            // 已最终提交
                            //console.log('已最终提交');

                            // 基本状态
                            that.app.status = 3;
                            that.app.disabled = true;
                            that.app.showErrors = that.paper.show_errors;
                            that.app.showAnswers = that.paper.show_answers;

                            // 分数
                            that.score = that.submit.score;
                            that.app.showScore = true;

                            return
                        }
                    }
                    // 未提交或非最终提交  答题中
                    // //console.log('未提交或非最终提交');

                    // 基本状态
                    that.app.status = 2;
                    that.app.disabled = false;
                    that.app.showErrors = false;
                    that.app.showAnswers = false;

                    // 倒计时 step=1秒
                    that.timeLeft = getTimeDelt(now, endsAt);
                    that.timeLeftTimer = window.setInterval(function () {
                        let now = (new Date()).getTime();
                        that.timeLeft = getTimeDelt(now, endsAt);


                        // 开启自动提交
                        that.allowAuto = true;

                        // 启动 自动提交 定时器 5秒
                        if (!that.autoTimer) {
                            
                            // TODO:在那时缩短时间用于调试
                            that.autoTimer = window.setInterval(function () {
                                // 定时提交
                                that.postExam(true)
                            }, 60000)
                        }
                        if (endsAt <= now) {
                            // 最后一次自动提交
                            that.postExam(false, true);
                        }
                    }, 1000);

                    return;
                } else if (now > endsAt) {
                    // 考试 结束
                    // //console.log('考试结束');

                    // 清除 倒计时 定时器
                    that.clearTimer();

                    // 基本状态
                    that.app.status = 3;
                    that.app.disabled = true;
                    that.app.showScore = true;

                    // 有提交，则显示作答数据、分数
                    if (that.submit) {
                        that.score = that.submit.score;
                        that.app.showSubmits = true;
                    } else {
                        that.score = 0;
                    }

                    // 判断试卷是否为公开查阅
                    if (3 === that.paper.status) {
                        // 公开查阅
                        that.app.showErrors = true;
                        that.app.showAnswers = true;
                    } else {
                        // 发布中
                        that.app.showErrors = that.paper.show_errors;
                        that.app.showAnswers = that.paper.show_answers;
                    }

                    return;
                } else {
                    // console.log('奇怪的时间状态');
                    that.app.disabled = true;

                    return;
                }
            },
            // preview模式
            getPreview(id) {
                let that = this;
                return GET_PREVIEW(id, function (res) {
                    if (!res.data || !res.data.hasOwnProperty('status')) {
                        that.$message.error('试卷获取失败');
                        return
                    }
                    if (!res.data.data) {
                        that.$message.error('无试题');
                    }

                    that.app.paper = res.data;

                    // 初始化模式
                    that.app.status = 0;

                    if (that.paper.data) {
                        // 获取正确答案集合
                        that.answers = getQuestionAnswers(that.paper.data);

                        // 生成空答案集合
                        that.app.submits = getQuestionKeyMap(that.paper.data);
                        //console.log('答案集合', that.submits);

                        // 预览模式
                        // 试题可答，不可提交，可以评分、重置
                        //console.log('预览模式');

                        // 可以编辑
                        that.app.disabled = false;

                        // 当前的显示状态
                        that.app.showSubmits = true;
                    } else {
                        // 不可以编辑
                        that.app.disabled = true;
                    }

                }).catch(err => {
                    if (err.response) {
                        that.$message.error(err.response.data);
                    } else {
                        console.log(err);
                    }
                });
            },
            // exam模式
            getPaper(id) {
                let that = this;
                return GET_EXAM(id, function (res) {
                    if (!res.data || !res.data.data) {
                        that.$message.error('试卷获取失败');
                        clearLocalStorage('exam');
                        return
                    }

                    // 试卷数据
                    that.app.paper = res.data;

                    // 姓名
                    that.nickname = that.paper.nickname;

                    // 有提交的数据
                    if (that.paper.submit) {
                        that.app.submit = that.paper.submit;
                    }

                    // 生成答案集合
                    that.app.submits = getQuestionKeyMap(that.paper.data);
                    if (that.submit && that.submit.data) {
                        mergeSubmit(that.submits, that.submit.data)
                    }

                    // 检查状态
                    // 学生考试结束后，是否显示错题、答案需要后台做限制
                    // 此模式下需要判断试卷状态、时钟检测
                    //console.log('exam模式');

                    that.checkStatus();
                }).catch(err => {
                    if (err.response) {
                        that.$message.error(err.response.data).then(function () {
                            if (err.response.data === '试卷不存在或不可见') {
                                clearLocalStorage('exam');
                                that.$router.push({
                                    name: "Home"
                                })
                            } else if (err.response.data === '已经交卷了') {
                                that.$router.push({
                                    name: "Home"
                                })
                            }
                        });
                    } else {
                        //console.log(err);
                    }
                });
            },
            // exam模式
            // 学生提交答案
            postExam(auto, force) {
                let that = this;
                if (2 !== that.status || 2 !== that.status) {
                    //console.log('无法提交，status=', that.status);
                    if (!auto) {
                        that.$message.error('无法提交');
                    }
                    return;
                }
                if (auto && !that.allowAuto) {
                    // console.log('不允许自动提交');
                    return;
				}
                if (!auto && !force) {
                    if (!window.confirm('确认交卷吗？交卷后无法更改')) {
                        return
                    }
                }
                //console.log('提交答案', that.submits, auto);
                SUBMIT_EXAM(that.$route.params.id, that.submits, auto, function (res) {
                    if (!res || !res.data || !res.data.hasOwnProperty('status')) {
                        that.$message.error('试卷提交失败');
                        return
                    }


                    // 提交的数据
                    //console.log(res.data);
                    that.app.submit = res.data;
                    if (that.submit.paper) {
                        that.app.paper = that.submit.paper;
                    }

                    if (auto) {
                        // 自动提交
                        // console.log('提交成功');
                        // } else if (auto && force) {
                        that.$message.success('自动保存成功');
                    } else {
                        // 最终提交
                        that.$message.success('提交成功');
                    }

                    // 提交后需要检查一次状态
                    that.checkStatus();
                }).catch(err => {
                    if (!auto) {
                        // 最终提交
                        if (err.response) {
                            //
                            that.$message.error('提交失败 ' + err.response.data);
                        } else {
                            // 程序错误
                            that.$message.error('提交失败 ' + err);
                        }
                    } else {
                        // 自动提交
                        if (err.response) {
                            //
                            that.$message.error('自动保存失败 ' + err.response.data);
                        } else {
                            // 程序错误
                            that.$message.error('自动保存失败 ' + err);
                        }
                    }
                });
            },
            // 预览 评分
            mark() {
                let that = this;
                that.app.showScore = true;
                that.app.showErrors = true;
                that.app.showAnswers = true;
                that.$message.success('检查完成');
                //console.log(that.submits);
            },
            // 预览 重置
            reset() {
                let that = this;
                that.app.showScore = false;
                that.app.showErrors = false;
                that.app.showAnswers = false;
                that.app.submits = getQuestionKeyMap(that.paper.data);
                that.$message.success('重置完成');
            },
            getTime() {
                let that = this;
                setInterval(() => {
                    GET_TIME(function (res) {
                        //console.log(res.data.time);
                    });
                }, 1000);
            }
        },
        computed: {
            totalScore() {
                if (this.paper.data && this.paper.length > 0) {
                    return countScore(this.paper.data);
                } else {
                    return this.paper.score;
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
	.exam {
		
		-moz-user-select: none; /*火狐*/
		
		-webkit-user-select: none; /*webkit浏览器*/
		
		-ms-user-select: none; /*IE10*/
		
		-khtml-user-select: none; /*早期浏览器*/
		
		user-select: none;
		
		margin-bottom: 300px;
	}
	
	.score-card {
		margin: 0 auto 20px auto;
		font-size: 20px;
		
		.item {
			display: flex;
			flex-direction: row;
			justify-content: center;
		}
		
		.item > span:first-child {
			flex-grow: 0;
			flex-shrink: 1;
			text-align: end;
			flex-basis: 100px;
			text-align-last: justify;
		}
		
		.item > span:last-child {
			flex-grow: 0;
			flex-shrink: 1;
			flex-basis: 100px;
			padding-left: 20px;
		}
	}
	
	.example-card {
		display: flex;
		justify-content: space-around;
		margin-bottom: 20px;
	}
	
	.example {
		border: 5px solid #1890ff;
		width: 5px;
		height: 5px;
		border-radius: 5px;
		display: inline-block;
		
		&.red {
			border-color: red;
		}
		
		&.green {
			border-color: #33cc33;
		}
	}
	
	.flat-button {
		padding: 10px 10px;
		margin-top: 10px;
		display: block;
		text-align: center;
	}

</style>